import type { FC } from 'react';
import { DrawerSection } from '@components/DrawerSection';
import IconMdi from '@components/IconMdi';
import { authProvider } from '@helpers/auth';
import { mdiOpenInNew } from '@mdi/js';
import Nav from '@src/routes';

import { useBlockPanelContent } from '../hooks/useBlockPanelContent';

interface DrawerBlockUsedWithinProps {
  data?: Array<{
    id: string;
    name?: string;
  }>;
  isBlock: boolean;
}

export const DrawerBlockUsedWithin: FC<DrawerBlockUsedWithinProps> = ({ data = [], isBlock }) => {
  const { getContent } = useBlockPanelContent(isBlock);

  if (!data.length) return null;

  const handleLinkClick = async (templateId: string) => {
    const searchParams = (await authProvider.getAuthSearchParams()) ?? '';
    const win = window.open(`${Nav.TemplateContract.replace(':id', templateId)}${searchParams}`);
    return win?.focus();
  };

  return (
    <DrawerSection title={getContent('fields.usage.label')}>
      <ul className="text-info-500 flex max-h-[134px] cursor-default flex-col items-start gap-1 overflow-auto text-sm">
        {data.map(({ id, name }) => (
          <li key={id} className="w-full py-1 pr-3">
            <button
              className="text-primary-600 flex w-full cursor-pointer justify-between"
              onClick={() => handleLinkClick(id)}
              role="link"
            >
              <p className="truncate text-xs no-underline hover:underline">{name}</p>
              <IconMdi
                className="ml-1"
                path={mdiOpenInNew}
                size={0.6}
                data-testid="block-icon-indicator:linked-library-block"
              />
            </button>
          </li>
        ))}
      </ul>
    </DrawerSection>
  );
};
